export const arTranslations = {
  hello: 'مرحبًا بك!',
  adelGreet: 'في وزارة العدل، الكويت.',
  adelIntro:
    ' أنا هنا لإجابتك عن الأسئلة المتعلقة بكل ما يقدمه موقع وزارة العدل في الكويت بما في ذلك التقاضي والإجراءات القانونية. ',
  talk: 'ابدأ التحدث',
  startTyping: 'ابدأ الكتابة...',
  en: 'الإنجليزية',
  ar: 'العربية',
  connecting: 'جارٍ الاتصال',
  tapMic: 'اضغط على الميكروفون للتحدث',
  poweredBy: 'بدعم من',
  adel: 'عادل',
  askByVoice: 'اسأل بالصوت',
  askByText: 'اسأل بالنص',
  backToChat: 'العودة إلى المحادثة',
  backToHome: 'العودة إلى المنزل',
  talkTo: 'تحدث إلى',
  noor: 'نور',
  loading: 'تحميل...',
  back: 'خلف',
  researching: 'جاري البحث',
  adelTalking: 'عادل يتحدث',
  noorTalking: 'نور تتحدث',
  adelListening: 'عادل يستمع  ',
  noorListening: 'نور تستمع',
  tapToTalk: 'اضغط للتحدث',
  tapToPause: 'اضغط للتوقف',
};
